<template>
    <div class="slot">
        <v-data-table
            :headers="headers"
            :items="slots"
            :items-per-page="10"
            class="elevation-1"
      		:search="search"
        >
			<template v-slot:top>
				<v-text-field
				v-model="search"
				label="Search"
				class="mx-4"
				></v-text-field>
			</template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
            </template>
        </v-data-table>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
					<v-select
                        :items = "filtered_applications"
                        item-value = "school"
                        label = "Assign Application"
                        v-model = "editedItem.assign_to"
					>
                        <template v-slot:item="{ item }">
                            <p>{{item.school}} - {{item.person}} - {{item.email}}</p>
                        </template>
                        <template v-slot:selection="{ item }">
                            <p>{{item.school}}</p>
                        </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="assignApplicationToSlot"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
    
</template>
<script>
import firebase from 'firebase'
import db from '../firestore'
  export default {
    data () {
      return {
      	dialog: false,
      	search: '',
        headers: [
			{ text: 'Date', value: 'date' },
			{ text: 'experiment_id', value: 'experiment_id' },
			{ text: 'set_id', value: 'set_id' },
			{ text: 'assign_to', value: 'assign_to' },
        	{ text: 'Actions', value: 'actions', sortable: false },
		],
      	editedIndex: -1,
      	editedItem: {},
        slots: [
        ],
        
		applications:[],
		filtered_applications:[],
      }
	},
	mounted(){
		var self = this;
		self.getSlots();
		self.getApplications();
    },
	methods:{
		getSlots: function(){
            var self = this;
			self.slots = [];
			db.collection("slots")
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                self.slots.push({
                    id: doc.id,
                    date: doc.data().date,
                    experiment_id: doc.data().experiment_id,
                    set_id: doc.data().set_id,
                    assign_to: doc.data().assign_to,
                    });
                });
                self.$forceUpdate();
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
        },
        
        getApplications() {
            var self = this;
			db.collection("applications")
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                self.applications.push({
                    id: doc.id,
                    school: doc.data().school,
                    person: doc.data().person,
                    email: doc.data().email,
                    experiment: doc.data().experiment,
                    selected_date: doc.data().selected_date
                    });
                });
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
        },
        filterApplications(){
            var self = this;
            var filtered_applications = [
                {
                    school:''
                }
            ];
            for(var application of self.applications){
                if(application.experiment == self.editedItem.experiment_id){
                    if(application.selected_date == self.editedItem.date){
                        filtered_applications.push(application);
                    }
                }
            }
            return filtered_applications;
        },
		editItem (item) {
            var self = this;
			self.editedIndex = self.slots.indexOf(item)
            self.editedItem = Object.assign({}, item)
            self.filtered_applications = self.filterApplications();
			self.dialog = true;
		},
		assignApplicationToSlot: function(){
            var self = this;
            db.collection("slots")
            .doc(self.editedItem.id)
            .update({
                assign_to: self.editedItem.assign_to
            })
            .then(() => {
                alert("Assign Success!");
			    self.dialog = false;
		        self.getSlots();
            })
            .catch((error) => {
            console.error("Error updating document: ", error);
            });
		},
	  }
  }
</script>